<template>
  <el-dialog v-dialogDrag :visible.sync="isModelDialog" :before-close="handleClose" class="title" width="1000px"
    title="整合记录" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="oper">
      <el-button type="danger" size="small" plain @click="deleteBatchlog">
        批量删除
      </el-button>
      <el-input v-model="keyword" placeholder="请输入关键字" suffix-icon="el-icon-search" class="input-with-select"
        size="small" @input="searchData">
      </el-input>
    </div>
    <div class="integrationRecordTable">
      <el-table ref="multipleTable" class="tableMain" :data="integrationRecordData" height="500"
        border @row-click="clickRow" @selection-change="handleSelectionChange">
        <el-table-column v-if="integrationRecordData.length > 0 ? true : false" type="selection" align="center">
        </el-table-column>
        <el-table-column prop="integrationName" label="整合名称">
        </el-table-column>
        <el-table-column prop="fileName" width="350px" label="文件名称" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <div style="display: flex;align-items:center;cursor: pointer">
              <img :src="nameIcon(row)" style="display:inline-block;flex-shrink: 0; margin-right: 6px;" />
              <div style="display: inline-block">
                {{ row.fileName }}
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="operDate" align="center" label="整合时间">
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="{ row }">
            <i class="el-icon-delete deleteIcon" title="删除" @click.stop="deleteRow(row)"></i>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import XtDesignService from "@/CommonDP/service/integratedModel-service";
import { tableRowIcon, openModelsLog } from "@/CommonDP/utils/docPublic";
export default {
  data() {
    return {
      isModelDialog: false,
      keyword: "",
      integrationRecordData: [],
      multipleSelection: []
    };
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj // 项目
    })
  },
  methods: {
    searchData() {
      this.openDialog();
    },
    async openDialog() {
      const { prjId } = this.prjInfo;
      const params = {
        prjId,
        pageNum: 1,
        pageSize: 9999,
        searchName: this.keyword
      };
      this.integrationRecordData = [];
      const res = await XtDesignService.queryIntegrationModelLogPage(params);
      this.integrationRecordData = res.data;
      console.log(res);
      this.isModelDialog = true;
    },
    handleClose() {
      this.isModelDialog = false;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 单个删除
    deleteRow(row) {
      this.$confirm("确定删除该条记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(async () => {
          try {
            await XtDesignService.batchIntegrationModelLog([row.integrationId]);
            this.$message.success("删除成功");
            this.openDialog();
          } catch (error) {
            this.$message.error(error);
          }
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },
    clickRow(row) {
      const { prjId, prjName } = this.prjInfo;
      openModelsLog(row, prjId, prjName);
    },
    // 批量删除
    deleteBatchlog() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("确定删除目前选中的整合记录？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
          closeOnPressEscape: false
        })
          .then(async () => {
            try {
              const ids = [];
              this.multipleSelection.forEach((ele) => {
                ids.push(ele.integrationId);
              });
              await XtDesignService.batchIntegrationModelLog(ids);
              this.$message.success("删除成功");
              this.openDialog();
            } catch (error) {
              this.$message.error(error);
            }
          })
          .catch(() => {
            this.$message.info("已取消");
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = [];
          });
      } else {
        this.$message.info("请至少选择一条需要删除的整合记录");
      }
    },
    nameIcon(row) {
      const reg = /\.(rvt|skp|3dm|nwc|nwd|ifc|dgn|rvm|ipt|vue)$/;
      if (row.fileName.match(reg)[0] === ".rvt") {
        row.fileType = 7;
        return tableRowIcon(row);
      } else {
        row.fileType = 18;
        return tableRowIcon(row);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-dialog__body {
  padding: 5px 20px !important;
}
.oper {
  width: 100%;
  height: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .input-with-select {
    width: 250px;
    /deep/.el-input__suffix {
      cursor: pointer;
    }
  }
}
.integrationRecordTable {
  width: 100%;
  height: 500px;
}
.deleteIcon {
  font-size: 16px;
  cursor: pointer;
}
</style>
